/** Sender may cancel NAV-locked transfer offers after this wait (matches backend). */
export const SECONDARY_TRANSFER_CANCEL_AFTER_MS = 5 * 60 * 1000;

export function msUntilOutgoingTransferCancel(requestedAtIso) {
  if (!requestedAtIso) return 0;
  const t = new Date(requestedAtIso).getTime();
  if (Number.isNaN(t)) return 0;
  return Math.max(0, t + SECONDARY_TRANSFER_CANCEL_AFTER_MS - Date.now());
}

export function formatMmSs(ms) {
  const sec = Math.ceil(ms / 1000);
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function canCancelOutgoingTransfer(row) {
  if (!row) return false;
  if (String(row.status || "").toUpperCase() !== "PENDING") return false;
  const tr = row.transfer_record;
  if (!tr || String(tr.status || "").toUpperCase() !== "AWAITING_RECEIVER") return false;
  return msUntilOutgoingTransferCancel(row.requested_at) <= 0;
}
